import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Settings2,
  ShieldCheck,
  Users,
  Upload,
  Settings as LucideSettings,
  Monitor,
  Warehouse,
} from "lucide-react";
import Modal from "../common/CommonModal";
import DeptHeaderFooterUpdater from "./DeptHeaderFooterUpdater";
import canUserSeeThis from "../common/CheckCanUserSeeThis";

const Settings = ({ rowsPerPage, setRowsPerPage }) => {
  const navigate = useNavigate();

  const currentUser = React.useMemo(
    () => JSON.parse(localStorage.getItem("currentUser") || "[]"),
    [],
  );
  const isAdmin = currentUser[0]?.accessgrp?.trim()?.toUpperCase() === "ADMIN";

  const hasCZAccess = canUserSeeThis("CZ");

  const adminActions = [
    {
      title: "Roles",
      icon: <ShieldCheck />,
      path: "/customer_control/roles",
      desc: "Manage user permissions and access levels.",
    },
    {
      title: "Users",
      icon: <Users />,
      path: "/customer_control/users",
      desc: "View, edit, and manage system users.",
    },
    {
      title: "GL Voucher Settings",
      icon: <Settings2 />,
      path: "/customer_control/gl_voucher_settings",
      desc: "Configure general ledger parameters.",
    },
    {
      title: "Inventory Master Upload",
      icon: <Upload />,
      path: "/stock_upload",
      desc: "Bulk upload stock and inventory data.",
    },
    {
      title: "Application Utilities",
      icon: <LucideSettings />,
      path: "/settings/application_utilities",
      desc: "Manage Application Settings",
    },
    {
      title: "Device Details",
      icon: <Monitor />,
      path: "/customer_control/device_details",
      desc: "Identify Devices",
    },
    {
      title: "Department Master",
      icon: <Warehouse />,
      path: "OPEN_DEPT_MODAL",
      desc: "Identify Departments",
    },
  ];

  const [isDeptModalOpen, setIsDeptModalOpen] = React.useState(false);

  const filteredActions = adminActions.filter((item) => {
    if (isAdmin) return true;
    if (item.title === "Application Utilities" && hasCZAccess) return true;
    return false;
  });

  return (
    <>
      <div className=" bg-gray-50 p-8">
        <div className=" mx-auto">
          <header className="mb-8">
            <h3 className="text-3xl font-bold text-gray-900">Settings</h3>
            <p className="text-gray-500">
              Manage your application preferences and administrative controls.
            </p>
          </header>

          {filteredActions.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredActions.map((item) => (
                <div
                  key={item.title}
                  onClick={() => {
                    if (item.path === "OPEN_DEPT_MODAL") {
                      setIsDeptModalOpen(true);
                    } else {
                      navigate(item.path);
                    }
                  }}
                  className="group p-6 bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md hover:border-blue-400 transition-all cursor-pointer"
                >
                  <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors">
                    {item.icon}
                  </div>
                  <h4 className="text-lg font-semibold text-gray-800">
                    {item.title}
                  </h4>
                  <p className="text-sm text-gray-500 mt-1">{item.desc}</p>
                </div>
              ))}
            </div>
          ) : (
            <div className="bg-yellow-50 border border-yellow-100 p-6 rounded-xl text-center">
              <p className="text-yellow-700 font-medium">Access Restricted</p>
              <p className="text-yellow-600 text-sm">
                Please contact your administrator for permission to view these
                settings.
              </p>
            </div>
          )}
        </div>
      </div>

      <Modal
        isOpen={isDeptModalOpen}
        onClose={() => setIsDeptModalOpen(false)}
        title="Department Master"
        size="xl"
      >
        <DeptHeaderFooterUpdater />
      </Modal>
    </>
  );
};

export default Settings;
